<template>
    <div
        v-if="mode === 'history' && camera && [CAMERA_MOVIE_TYPE.HLS_CAMERA, CAMERA_MOVIE_TYPE.SAFIE, CAMERA_MOVIE_TYPE.MEDIAMTX].includes(camera.movieType)">
        <vs-row style="margin-top: 4px;">
            <vs-col class="w-full forward-layer relative">
                <div class="carousel-wrap pb-2" @scroll="handleScroll">
                    <div v-for="(thumbnailUrl, index) in thumbnailUrlList" :key="index"
                        class="carousel-item flex relative rounded m-0"
                        :style="{ width: carouselItemWidth, cursor: thumbnailUrl.path !== noImageUrl ? 'pointer' : null, 'border': index === selectedHour ? ' 2px solid #48A0F4' : null, 'box-shadow': index === selectedHour ? '0px 2px 6px #333333' : null, }"
                        @click="setTargetHour(thumbnailUrl.path, index)">
                        <div class="flex justify-center items-center" style="color: white;"
                            :style="{ 'background-color': index === selectedHour ? '#48A0F4' : '#333333', }">
                            {{ ('00' + index).slice(-2) }}:00
                        </div>
                        <div style="width: 100%; height: 120px; box-sizing: border-box; position: relative; box-shadow: inset 2px 0px 0px #0000001F; background-color: #BDBDBD;"
                            :style="{ border: (thumbJstHHMM(thumbnailUrl.path) === targetHour) ? '4px solid #48A0F4' : null, }">
                            <img v-if="thumbnailUrl.src" :src="thumbnailUrl.src"
                                :style="{ width: thumbnailUrl.path !== noImageUrl ? '100%' : '32px', }"
                                style="height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto;"
                                crossorigin />
                        </div>
                    </div>
                </div>
                <div class="flex items-center jump-carousel-parent jump-carousel-parent--left">
                    <div class="flex items-center justify-center jump-carousel-button mt-8"
                        @click.stop="jumpCarouselPosition(-1)">
                        <feather-icon icon="ChevronLeftIcon" svgClasses="h-9 w-9" />
                    </div>
                </div>
                <div class="flex items-center jump-carousel-parent jump-carousel-parent--right">
                    <div class="flex items-center justify-center jump-carousel-button mt-8"
                        @click.stop="jumpCarouselPosition(1)">
                        <feather-icon icon="ChevronRightIcon" svgClasses="h-9 w-9" />
                    </div>
                </div>
            </vs-col>
        </vs-row>

        <vs-row style="height: 20px;">
            <!-- スクロールブロック -->
            <vs-col class="flex w-full justify-center items-start forward-layer ">
                <div @click="setCarouselPosition(4)" class="carousel-summary-block m-2 cursor-pointer"
                    :style="{ 'background-color': (carouselScrollRate <= (1 / 3)) ? '#48A0F4' : AISEA_COLOR.LIGHT_GRAY }" />
                <div @click="setCarouselPosition(12)" class="carousel-summary-block m-2 cursor-pointer"
                    :style="{ 'background-color': (carouselScrollRate > (1 / 3) && carouselScrollRate < (2 / 3)) ? '#48A0F4' : AISEA_COLOR.LIGHT_GRAY }" />
                <div @click="setCarouselPosition(20)" class="carousel-summary-block m-2 cursor-pointer"
                    :style="{ 'background-color': (carouselScrollRate >= (2 / 3)) ? '#48A0F4' : AISEA_COLOR.LIGHT_GRAY }" />
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import { CAMERA_MOVIE_TYPE } from "@/config/const";
export default {
    props: {
        camera: { type: Object, required: true },
        mode: { type: String, required: true },
        thumbnailUrlList: { type: Array, required: true },
        carouselItemWidth: { type: String, required: false },
        selectedHour: { type: Number, required: false },
        setTargetHour: { type: Function, required: false },
        thumbJstHHMM: { type: Function, required: false },
        targetHour: { type: String, required: false },
        noImageUrl: { type: String, required: false },
        jumpCarouselPosition: { type: Function, required: false },
        setCarouselPosition: { type: Function, required: false },
        carouselScrollRate: { type: Number, required: false },
        AISEA_COLOR: { type: Object, required: false }
    },
    data() {
        return {
            CAMERA_MOVIE_TYPE
        }
    },
    methods: {
        handleScroll(e) {
            const el = e.target;
            const rate = el.scrollLeft / (el.scrollWidth - el.getBoundingClientRect().width);
            this.$emit('scroll', rate);
        }
    }
}
</script>
<style lang="scss">
.carousel-wrap {
    scroll-snap-type: x mandatory;
    white-space: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.carousel-item {
    scroll-snap-align: center;
    display: inline-block;
    white-space: normal;
}

.jump-carousel-parent {
    position: absolute;
    top: 0px;
    color: gray;
    z-index: 0;
    height: 140px;
    padding: 1rem;

    &--left {
        left: 0px;
    }

    &--right {
        right: 0px;
    }

    .jump-carousel-button {
        background-color: silver;
        opacity: 0.8;
        border-radius: 50%;
        height: 3rem;
        width: 3rem;
        z-index: 9;
        cursor: pointer;
    }
}

.carousel-summary-block {
    width: 2rem;
    height: 0.4rem;
    background-color: #bdbdbd;
}
</style>